import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.patients.detail');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-patients-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.patients.detail/view.scss */
:host {
  min-width: 0;
  container: page-patients-detail/inline-size;
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: 100%;
  overflow-x: hidden;
}

.patient-detail-main {
  --workflow-brand: var(--wb-brand, #006aa6);
  --workflow-brand-dark: var(--wb-brand-hover, #005585);
  --workflow-success: #16a34a;
  --workflow-warning: #d97706;
  --workflow-border: var(--wb-border, #dce4e8);
  --workflow-muted: var(--wb-muted, #56686e);
  --workflow-canvas: var(--wb-surface-muted, #f7f9fa);
}

.patient-workspace {
  display: grid;
  grid-template-columns: 15rem minmax(0, 1fr) 16.5rem;
  min-height: 0;
}

.workflow-rail {
  border-right: 1px solid var(--workflow-border);
  background: var(--workflow-canvas);
  padding: 2rem 1.5rem;
}

.workflow-steps {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.workflow-step {
  position: relative;
  min-height: 11rem;
  color: var(--workflow-muted);
}

.workflow-step-action {
  display: grid;
  width: 100%;
  grid-template-columns: 2.25rem minmax(0, 1fr);
  gap: 0.75rem;
  border: 0;
  border-radius: 0.625rem;
  background: transparent;
  padding: 0;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.workflow-step-action:hover:not(:disabled) .workflow-step-title {
  color: var(--workflow-brand-dark);
  text-decoration: underline;
  text-underline-offset: 0.2rem;
}

.workflow-step-action:focus-visible {
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: 0.35rem;
}

.workflow-step-action:disabled {
  cursor: not-allowed;
}

.workflow-step:last-child {
  min-height: 0;
}

.workflow-step:not(:last-child)::after {
  position: absolute;
  top: 2.6rem;
  bottom: 0.35rem;
  left: 1.08rem;
  width: 2px;
  content: "";
  background: #d1d5db;
}

.workflow-step[data-state=complete]:not(:last-child)::after {
  background: var(--workflow-success);
}

.workflow-step[data-state=active]:not(:last-child)::after {
  background: var(--workflow-brand);
}

.workflow-step-marker {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  align-items: center;
  justify-content: center;
  border: 2px solid #d1d5db;
  border-radius: 9999px;
  background: #fff;
  color: var(--workflow-muted);
  font-size: 0.875rem;
  font-weight: 700;
}

.workflow-step[data-state=active] .workflow-step-marker {
  border-color: var(--workflow-brand);
  background: var(--workflow-brand);
  color: #fff;
  box-shadow: 0 0 0 4px var(--wb-brand-soft, #eaf4fa);
}

.workflow-step[data-state=complete] .workflow-step-marker {
  border-color: var(--workflow-success);
  background: var(--workflow-success);
  color: #fff;
}

.workflow-step-title {
  padding-top: 0.35rem;
  color: #374151;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.5;
}

.workflow-step[data-state=active] .workflow-step-title {
  color: var(--workflow-brand-dark);
}

.workflow-step[data-state=complete] .workflow-step-title {
  color: #166534;
}

.workflow-step-caption {
  margin-top: 0.55rem;
  color: var(--workflow-muted);
  font-size: 0.75rem;
  line-height: 1.55;
}

.workflow-editor {
  padding: 2rem;
}

.workflow-editor-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.workflow-empty-state {
  display: flex;
  min-height: 27rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  border: 1px dashed #cbd5e1;
  border-radius: 0.75rem;
  background: #f8fafc;
  padding: 3rem 1.5rem;
  text-align: center;
}

.approved-scenario-card {
  margin-top: 1.25rem;
  overflow: hidden;
  border: 1px solid #d8e2e7;
  border-radius: 0.875rem;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.approved-scenario-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.25rem 1rem;
}

.approved-scenario-heading {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.875rem;
}

.approved-scenario-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #dcfce7;
  color: #15803d;
  font-size: 0.875rem;
}

.approved-scenario-status-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.approved-scenario-eyebrow {
  color: #166534;
  font-size: 0.75rem;
  font-weight: 700;
}

.approved-scenario-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  border: 1px solid #bbf7d0;
  border-radius: 9999px;
  background: #f0fdf4;
  padding: 0.15rem 0.5rem;
  color: #15803d;
  font-size: 0.6875rem;
  font-weight: 700;
}

.approved-scenario-title {
  margin-top: 0.35rem;
  color: #111827;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.45;
}

.approved-scenario-regenerate {
  display: inline-flex;
  min-height: 2.5rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  background: #fff;
  padding: 0.5rem 0.75rem;
  color: #4b5563;
  font-size: 0.75rem;
  font-weight: 700;
}

.approved-scenario-regenerate:hover:not(:disabled) {
  border-color: #9ca3af;
  background: #f9fafb;
}

.approved-scenario-regenerate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.approved-scenario-regenerate:focus-visible {
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: 2px;
}

.approved-scenario-body {
  padding: 0 1.25rem 1.25rem;
}

.approved-scenario-summary {
  max-width: 72rem;
  color: #4b5563;
  font-size: 0.8125rem;
  line-height: 1.7;
  white-space: pre-wrap;
}

.approved-scenario-goal {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: 1rem;
  border: 1px solid #dbeafe;
  border-radius: 0.625rem;
  background: #f8fbff;
  padding: 0.75rem 0.875rem;
}

.approved-scenario-goal-icon {
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 0.75rem;
}

.approved-scenario-goal p {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
}

.approved-scenario-goal strong {
  display: block;
  margin-top: 0.15rem;
  color: #1f2937;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.6;
}

.approved-scenario-details {
  padding-bottom: 1rem;
}

.approved-scenario-details summary {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 1.25rem;
  color: #374151;
  cursor: pointer;
  list-style: none;
}

.approved-scenario-details summary::-webkit-details-marker {
  display: none;
}

.approved-scenario-details[open] summary {
  padding-bottom: 1rem;
}

.approved-scenario-details-label {
  display: inline-flex;
  min-height: 2.5rem;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  background: #fff;
  padding: 0.5rem 0.75rem;
  color: #334155;
  font-size: 0.75rem;
  font-weight: 700;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;
}

.approved-scenario-details-label i {
  color: var(--workflow-brand);
}

.approved-scenario-details summary:hover .approved-scenario-details-label {
  border-color: var(--wb-brand-border, #b3d8eb);
  background: #f8fbff;
  color: var(--workflow-brand);
}

.approved-scenario-details summary:focus-visible {
  outline: none;
}

.approved-scenario-details summary:focus-visible .approved-scenario-details-label {
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: 2px;
}

.approved-scenario-counts {
  margin-left: auto;
  overflow: hidden;
  color: #64748b;
  font-size: 0.6875rem;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approved-scenario-chevron {
  color: #64748b;
  font-size: 0.75rem;
  transition: transform 160ms ease;
}

.approved-scenario-details[open] .approved-scenario-chevron {
  transform: rotate(180deg);
}

.approved-scenario-detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
}

.approved-scenario-detail-section {
  min-width: 0;
  padding: 1rem 1.25rem 1.25rem;
}

.approved-scenario-detail-section + .approved-scenario-detail-section {
  border-left: 1px solid #e5e7eb;
}

.approved-scenario-detail-section h4 {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  color: #374151;
  font-size: 0.75rem;
  font-weight: 700;
}

.approved-scenario-detail-section h4 i {
  width: 1rem;
  color: #64748b;
  text-align: center;
}

.approved-scenario-detail-section ul,
.approved-scenario-detail-section ol {
  display: grid;
  gap: 0.45rem;
  margin: 0.75rem 0 0;
  padding-left: 1.1rem;
  color: #4b5563;
  font-size: 0.75rem;
  line-height: 1.55;
}

.approved-scenario-detail-section ul {
  list-style: disc;
}

.approved-scenario-detail-section ol {
  list-style: decimal;
}

.approved-scenario-safety {
  background: #fffdf5;
}

.approved-scenario-safety h4,
.approved-scenario-safety h4 i {
  color: #92400e;
}

.approved-scenario-cost-note {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  border-top: 1px solid #f3f4f6;
  padding: 0.625rem 1.25rem;
  color: #6b7280;
  font-size: 0.6875rem;
  line-height: 1.5;
}

.prompt-tabs {
  display: flex;
  margin-top: 1.75rem;
  border-bottom: 1px solid var(--workflow-border);
}

.prompt-tab {
  position: relative;
  min-height: 3rem;
  border: 0;
  background: transparent;
  padding: 0 1.1rem;
  color: var(--workflow-muted);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
}

.prompt-tab::after {
  position: absolute;
  right: 0;
  bottom: -1px;
  left: 0;
  height: 3px;
  content: "";
  background: transparent;
}

.prompt-tab[aria-selected=true] {
  color: var(--workflow-brand-dark);
}

.prompt-tab[aria-selected=true]::after {
  background: var(--workflow-brand);
}

.prompt-tab:focus-visible {
  z-index: 1;
  border-radius: 0.375rem;
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: -3px;
}

.prompt-translation-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  border: 1px solid #c7d2fe;
  border-radius: 0.625rem;
  background: #eef2ff;
  padding: 0.875rem 1rem;
}

.prompt-translation-action {
  display: inline-flex;
  min-height: 2.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid var(--workflow-brand);
  border-radius: 0.5rem;
  background: #fff;
  padding: 0.625rem 0.875rem;
  color: var(--workflow-brand-dark);
  font-size: 0.75rem;
  font-weight: 700;
}

.prompt-translation-action:hover:not(:disabled) {
  background: var(--wb-brand-soft, #eaf4fa);
}

.prompt-translation-action:disabled {
  border-color: #d1d5db;
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.prompt-translation-action:focus-visible {
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: 2px;
}

.prompt-translation-status {
  margin-top: 0.75rem;
  border: 1px solid #bfdbfe;
  border-radius: 0.5rem;
  background: #eff6ff;
  padding: 0.625rem 0.75rem;
  color: #1e40af;
  font-size: 0.75rem;
  line-height: 1.6;
}

.prompt-translation-status[data-status=stale],
.prompt-translation-status[data-status=failed] {
  border-color: #fcd34d;
  background: #fffbeb;
  color: #92400e;
}

.prompt-panel {
  padding-top: 1.5rem;
}

.prompt-panel[hidden] {
  display: none;
}

.ai-original-compare {
  margin-top: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  background: #f9fafb;
  padding: 0.75rem 0.875rem;
}

.ai-original-compare summary {
  display: inline-flex;
  min-height: 1.75rem;
  align-items: center;
  gap: 0.5rem;
  color: #4b5563;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
}

.prompt-textarea,
.prompt-readonly {
  display: block;
  width: 100%;
  min-height: 18.5rem;
  margin-top: 1rem;
  border: 1px solid #9ca3af;
  border-radius: 0.5rem;
  background: #fff;
  padding: 1rem;
  color: #111827;
  font-size: 0.875rem;
  line-height: 1.85;
}

.prompt-textarea {
  resize: vertical;
}

.prompt-textarea:focus {
  border-color: var(--workflow-brand);
  outline: 3px solid var(--wb-focus, rgba(0, 106, 166, 0.2));
  outline-offset: 0;
}

.prompt-translation-card {
  margin-top: 1rem;
  border: 1px solid #bfdbfe;
  border-radius: 0.625rem;
  background: #f8fbff;
  padding: 1rem;
}

.prompt-translation-card[data-status=stale],
.prompt-translation-card[data-status=failed] {
  border-color: #fcd34d;
  background: #fffbeb;
}

.prompt-translation-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.prompt-translation-card-header h3 {
  color: #1f2937;
  font-size: 0.8125rem;
  font-weight: 700;
}

.prompt-translation-card-header span {
  flex: 0 0 auto;
  border-radius: 9999px;
  background: #dbeafe;
  padding: 0.2rem 0.5rem;
  color: #1d4ed8;
  font-size: 0.6875rem;
  font-weight: 700;
}

.prompt-translation-card[data-status=stale] .prompt-translation-card-header span,
.prompt-translation-card[data-status=failed] .prompt-translation-card-header span {
  background: #fef3c7;
  color: #92400e;
}

.prompt-translation-copy {
  margin-top: 0.75rem;
  color: #1f2937;
  font-size: 0.875rem;
  line-height: 1.85;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.prompt-translation-wait {
  margin-top: 0.75rem;
  color: #4b5563;
  font-size: 0.8125rem;
}

.prompt-translation-disclaimer {
  margin-top: 0.75rem;
  border-top: 1px solid #dbeafe;
  padding-top: 0.625rem;
  color: #64748b;
  font-size: 0.75rem;
  line-height: 1.6;
}

.prompt-evidence {
  margin-top: 1.75rem;
}

.evidence-row + .evidence-row {
  border-top: 1px solid var(--workflow-border);
}

.evidence-row summary {
  display: flex;
  min-height: 4rem;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  color: #374151;
  font-size: 0.8125rem;
  cursor: pointer;
  list-style: none;
}

.evidence-row summary::-webkit-details-marker {
  display: none;
}

.evidence-row summary:focus-visible {
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: -3px;
}

.evidence-icon {
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 2px solid currentColor;
  border-radius: 9999px;
}

.evidence-row-confirmed .evidence-icon,
.evidence-row-confirmed .evidence-count {
  color: var(--workflow-success);
}

.evidence-row-warning .evidence-icon,
.evidence-row-warning .evidence-count {
  color: var(--workflow-warning);
}

.evidence-row-muted .evidence-icon,
.evidence-row-muted .evidence-count {
  color: #64748b;
}

.evidence-count {
  min-width: 1.5rem;
  font-size: 0.875rem;
  font-weight: 700;
  text-align: center;
}

.evidence-chevron {
  color: #6b7280;
  transition: transform 160ms ease;
}

.evidence-row[open] .evidence-chevron {
  transform: rotate(180deg);
}

.evidence-list {
  margin: 0;
  padding: 0 1rem 1rem 3.7rem;
  color: #4b5563;
  font-size: 0.8125rem;
  line-height: 1.65;
  list-style: disc;
}

.evidence-empty {
  padding: 0 1rem 1rem 3.7rem;
  color: #9ca3af;
  font-size: 0.75rem;
}

.evidence-subtitle {
  padding: 0.25rem 1rem 0.5rem 3.7rem;
  color: #4b5563;
  font-size: 0.75rem;
  font-weight: 700;
}

.approval-panel {
  display: flex;
  min-width: 0;
  border-left: 1px solid var(--workflow-border);
  background: #fff;
  padding: 2rem 1.25rem;
}

.approval-fieldset {
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  border: 0;
  padding: 0;
}

.approval-checklist {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin: 1.75rem 0 0;
  padding: 0 0 1.5rem;
  border-bottom: 1px solid var(--workflow-border);
  list-style: none;
}

.approval-checklist li {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  color: #4b5563;
  font-size: 0.8125rem;
  line-height: 1.5;
}

.approval-check-icon {
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 2px solid #cbd5e1;
  border-radius: 9999px;
  color: #94a3b8;
}

.approval-checklist li[data-complete=true] .approval-check-icon {
  border-color: var(--workflow-success);
  color: var(--workflow-success);
}

.approval-attestation {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-top: 1.5rem;
  border-radius: 0.5rem;
  background: #f8fafc;
  padding: 0.875rem;
  color: #374151;
  font-size: 0.75rem;
  line-height: 1.55;
  cursor: pointer;
}

.approval-complete {
  display: flex;
  gap: 0.65rem;
  margin-top: 1.5rem;
  border: 1px solid #bbf7d0;
  border-radius: 0.5rem;
  background: #f0fdf4;
  padding: 0.875rem;
  color: #166534;
  font-size: 0.8125rem;
}

.approval-actions {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-top: auto;
  padding-top: 2rem;
}

.approval-primary,
.approval-secondary,
.approval-cost-action {
  display: inline-flex;
  min-height: 3rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding: 0.65rem 0.85rem;
  font-size: 0.8125rem;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  transition: background-color 160ms ease, border-color 160ms ease;
}

.approval-primary {
  border: 1px solid var(--workflow-brand);
  background: var(--workflow-brand);
  color: #fff;
}

.approval-primary:hover:not(:disabled) {
  border-color: var(--workflow-brand-dark);
  background: var(--workflow-brand-dark);
}

.approval-primary:disabled {
  border-color: #d1d5db;
  background: #d1d5db;
  color: #f9fafb;
  cursor: not-allowed;
}

.approval-secondary {
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
}

.approval-secondary:hover:not(:disabled),
.approval-cost-action:hover:not(:disabled) {
  background: #f9fafb;
}

.approval-cost-action {
  border: 1px solid #d1d5db;
  background: #fff;
  color: #4b5563;
  font-size: 0.75rem;
}

.approval-primary:focus-visible,
.approval-secondary:focus-visible,
.approval-cost-action:focus-visible {
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: 2px;
}

@container page-patients-detail (min-width: 1280px) and (max-width: 1799px) {
  .patient-detail-viewport {
    width: 100%;
    max-width: 100%;
  }
  .patient-detail-viewport > nav,
  .patient-detail-viewport > .patient-detail-main {
    width: 100%;
    max-width: 100%;
  }
  .patient-detail-main {
    padding: 0.875rem 1.25rem 1.5rem;
  }
  .patient-workspace {
    grid-template-columns: 12.5rem minmax(0, 1fr) 13.75rem;
  }
  .workflow-rail {
    padding: 1.5rem 1rem;
  }
  .workflow-step {
    min-height: 8.75rem;
  }
  .workflow-editor {
    padding: 1.5rem;
  }
  .workflow-empty-state {
    min-height: 21.5rem;
    padding: 2.25rem 1.25rem;
  }
  .prompt-textarea,
  .prompt-readonly {
    min-height: 14.75rem;
  }
  .approval-panel {
    padding: 1.5rem 1rem;
  }
  .approval-checklist {
    gap: 1rem;
    margin-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
}
@container page-patients-detail (max-width: 1279px) {
  .patient-workspace {
    grid-template-columns: minmax(0, 1fr);
    min-height: 0;
  }
  .workflow-rail {
    border-right: 0;
    border-bottom: 1px solid var(--workflow-border);
    padding: 1.25rem 1.5rem;
  }
  .workflow-steps {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
  }
  .workflow-step,
  .workflow-step:last-child {
    min-height: 0;
  }
  .workflow-step:not(:last-child)::after {
    top: 1.08rem;
    right: -0.6rem;
    bottom: auto;
    left: 2.65rem;
    width: auto;
    height: 2px;
  }
  .approval-panel {
    border-top: 1px solid var(--workflow-border);
    border-left: 0;
    padding: 1.5rem 2rem;
  }
  .approval-checklist {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
  }
  .approval-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 0;
  }
}
@container page-patients-detail (max-width: 767px) {
  .workflow-rail,
  .workflow-editor,
  .approval-panel {
    padding: 1.25rem 1rem;
  }
  .approved-scenario-header {
    align-items: stretch;
    flex-direction: column;
  }
  .approved-scenario-regenerate {
    width: 100%;
  }
  .approved-scenario-counts {
    display: none;
  }
  .approved-scenario-detail-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .approved-scenario-detail-section + .approved-scenario-detail-section {
    border-top: 1px solid #e5e7eb;
    border-left: 0;
  }
  .workflow-steps {
    display: flex;
    gap: 0;
  }
  .workflow-step,
  .workflow-step:last-child {
    min-height: 7rem;
  }
  .workflow-step:last-child {
    min-height: 0;
  }
  .workflow-step:not(:last-child)::after {
    top: 2.6rem;
    right: auto;
    bottom: 0.35rem;
    left: 1.08rem;
    width: 2px;
    height: auto;
  }
  .workflow-editor-header {
    flex-direction: column;
  }
  .workflow-empty-state {
    min-height: 22rem;
    padding: 2rem 1rem;
  }
  .prompt-tabs {
    overflow-x: auto;
  }
  .prompt-translation-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .prompt-translation-action {
    width: 100%;
  }
  .prompt-tab {
    flex: 1 0 auto;
    padding: 0 0.75rem;
  }
  .prompt-textarea,
  .prompt-readonly {
    min-height: 15rem;
  }
  .approval-checklist,
  .approval-actions {
    display: flex;
  }
}
@container page-patients-detail (max-width: 1279px) {
  .workflow-steps {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
  }
  .workflow-step, .workflow-step:last-child {
    min-height: 0;
  }
  .workflow-step:not(:last-child)::after {
    display: none;
  }
  .workflow-step-action {
    gap: 0.5rem;
  }
}`],
})
export class PagePatientsDetailComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public saving: boolean = false;
    public editing: boolean = false;
    public promptDrafting: boolean = false;
    public promptDraftConfirming: boolean = false;
    public promptSaving: boolean = false;
    public promptEditing: boolean = false;
    public promptActionMessage: string = '';
    public promptTranslating: boolean = false;
    public promptTranslationConfirming: boolean = false;
    public promptTranslation: any = {
        visible: false,
        status: 'idle',
        message: '',
        positive_prompt_ko: '',
        negative_prompt_ko: ''
    };
    public promptDraftProgress: any = {
        visible: false,
        status: 'idle',
        stage: '',
        label: '',
        completed_steps: 0,
        total_steps: 0
    };
    public activePromptTab: 'positive' | 'negative' = 'positive';
    public patientPanelOpen: boolean = false;
    public scenarioReviewMode: boolean = false;
    public statementOrganizing: boolean = false;
    public statementOrganizeMessage: string = '';
    public treatmentScenarioGenerating: boolean = false;
    public treatmentScenarioSaving: boolean = false;
    public treatmentScenarioEditing: boolean = false;
    public treatmentScenarioForm: any = {};
    public treatmentScenarioActionMessage: string = '';
    public treatmentScenarioProgress: any = {
        visible: false,
        status: 'idle',
        stage: '',
        label: '',
        completed_steps: 0,
        total_steps: 0
    };
    public errorMessage: string = '';
    public patientId: string = '';
    public patient: any = null;
    public form: any = {};
    public promptForm: any = {};
    public csrfToken: string = '';
    public currentYear: number = new Date().getFullYear();
    public currentDate: string = new Date().toISOString().slice(0, 10);
    public scenarioDescriptionMaxLength: number = 1500;
    public patientStatementMaxLength: number = 5000;
    public scenarioContextItemMaxLength: number = 600;
    public traumaTypeDetailMaxLength: number = 80;
    public positivePromptMaxLength: number = 3000;
    public negativePromptMaxLength: number = 1500;
    public conflictMessage: string = '';
    private loadSequence: number = 0;
    private routerSub: any;
    private originalFormState: string = '';
    private originalPromptFormState: string = '';
    private sessionEndApproved: boolean = false;
    private navigationConfirmation: Promise<boolean> | null = null;
    private promptDraftProgressPollTimer: any = null;
    private promptDraftProgressPollSequence: number = 0;
    private promptDraftOperationSequence: number = 0;
    private treatmentScenarioProgressPollTimer: any = null;
    private treatmentScenarioProgressPollSequence: number = 0;
    private treatmentScenarioOperationSequence: number = 0;
    private statementOrganizeOperationSequence: number = 0;
    private promptTranslationOperationSequence: number = 0;
    private promptTranslationRequestSequence: number = 0;

    public genders: any[] = [
        { value: 'unspecified', label: '미응답' },
        { value: 'female', label: '여성' },
        { value: 'male', label: '남성' },
        { value: 'other', label: '기타' }
    ];

    public traumaTypes: any[] = [
        { value: 'traffic_accident', label: '교통사고' },
        { value: 'flight_related', label: '비행 관련' },
        { value: 'disaster_accident', label: '재난·사고' },
        { value: 'violence_crime', label: '폭력·범죄' },
        { value: 'loss_bereavement', label: '상실·사별' },
        { value: 'other', label: '기타' }
    ];

    public scenarioTypes: any[] = [
        { value: '', label: '미지정' }
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) {
        this.patientId = String(WizRoute.segment.id || '').trim().toLowerCase();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (!(event instanceof NavigationEnd)) return;
            const nextId = String(WizRoute.segment.id || '').trim().toLowerCase();
            if (nextId === this.patientId) return;
            ++this.loadSequence;
            ++this.promptDraftOperationSequence;
            ++this.treatmentScenarioOperationSequence;
            ++this.statementOrganizeOperationSequence;
            this.stopPromptDraftProgressPolling();
            this.stopTreatmentScenarioProgressPolling();
            this.resetPromptTranslation();
            this.promptDraftConfirming = false;
            this.promptDrafting = false;
            this.patientId = nextId;
            if (!/^[0-9a-f]{32}$/.test(this.patientId)) {
                this.patient = null;
                this.loading = false;
                this.errorMessage = '환자를 찾을 수 없습니다.';
                await this.service.render();
                return;
            }
            await this.load(true);
            await this.openRequestedScenarioEditor();
        });
        if (!/^[0-9a-f]{32}$/.test(this.patientId)) {
            this.loading = false;
            this.errorMessage = '환자를 찾을 수 없습니다.';
            await this.service.render();
            return;
        }
        await this.load();
        await this.openRequestedScenarioEditor();
    }

    public ngOnDestroy() {
        ++this.loadSequence;
        ++this.promptDraftOperationSequence;
        ++this.treatmentScenarioOperationSequence;
        ++this.statementOrganizeOperationSequence;
        this.stopPromptDraftProgressPolling();
        this.stopTreatmentScenarioProgressPolling();
        this.resetPromptTranslation();
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public message(data: any, fallback: string) {
        if (typeof data === 'string') return data;
        return data?.message || fallback;
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    public async load(force: boolean = false) {
        if (!force && this.hasUnsavedChanges()) return;
        if (!/^[0-9a-f]{32}$/.test(this.patientId)) {
            ++this.loadSequence;
            this.patient = null;
            this.loading = false;
            this.errorMessage = '환자를 찾을 수 없습니다.';
            await this.service.render();
            return;
        }
        const sequence = ++this.loadSequence;
        this.resetPromptTranslation();
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get', { id: this.patientId });
            if (sequence !== this.loadSequence) return;
            if (code === 200) {
                this.stopPromptDraftProgressPolling();
                this.stopTreatmentScenarioProgressPolling();
                this.patient = data.patient;
                this.scenarioTypes = [
                    { value: '', label: '미지정' },
                    ...(data.scenario_options || [])
                ];
                this.csrfToken = data.csrf_token || '';
                this.editing = false;
                this.promptEditing = false;
                this.activePromptTab = 'positive';
                this.patientPanelOpen = false;
                this.scenarioReviewMode = false;
                this.statementOrganizing = false;
                this.statementOrganizeMessage = '';
                this.treatmentScenarioEditing = false;
                this.treatmentScenarioGenerating = false;
                this.treatmentScenarioSaving = false;
                this.treatmentScenarioForm = {};
                this.treatmentScenarioActionMessage = '';
                const treatmentProgress =
                    this.patient?.treatment_scenario_progress || {};
                if (treatmentProgress.status === 'in_progress') {
                    this.treatmentScenarioGenerating = true;
                    this.applyTreatmentScenarioProgress(treatmentProgress);
                    this.startTreatmentScenarioProgressPolling('', true);
                } else {
                    this.treatmentScenarioGenerating = false;
                    if (!['completed', 'failed'].includes(
                        String(this.treatmentScenarioProgress?.status || '')
                    )) {
                        this.resetTreatmentScenarioProgress();
                    }
                }
                this.originalFormState = '';
                this.originalPromptFormState = '';
                this.conflictMessage = '';
                this.promptActionMessage = '';
                const progress = this.patient?.prompt_draft_progress || {};
                if (progress.status === 'in_progress') {
                    this.promptDrafting = true;
                    this.applyPromptDraftProgress(progress);
                    this.startPromptDraftProgressPolling('', true);
                } else {
                    this.promptDrafting = false;
                    if (!['completed', 'failed'].includes(
                        String(this.promptDraftProgress?.status || '')
                    )) {
                        this.resetPromptDraftProgress();
                    }
                }
                return;
            }
            this.patient = null;
            this.errorMessage = this.message(data, '환자 정보를 불러오지 못했습니다.');
        } catch (error) {
            if (sequence !== this.loadSequence) return;
            this.patient = null;
            this.errorMessage = '환자 정보를 불러오지 못했습니다.';
        } finally {
            if (sequence !== this.loadSequence) return;
            this.loading = false;
            await this.service.render();
            if (this.patient) {
                setTimeout(
                    () => document.getElementById('patient-detail-page-title')?.focus(),
                    0
                );
            }
        }
    }

    public async startEdit(scenarioReviewMode: boolean = false) {
        if (
            !this.patient
            || this.promptEditing
            || this.promptDrafting
            || this.promptSaving
            || this.promptTranslating
            || this.promptTranslationConfirming
            || this.statementOrganizing
        ) return;
        this.scenarioReviewMode = scenarioReviewMode;
        const context = this.patient.scenario_context || {};
        this.form = {
            birth_date: this.patient.birth_date || '',
            birth_year: this.patient.birth_year || '',
            gender: this.patient.gender || 'unspecified',
            trauma_type: this.patient.trauma_type || 'other',
            trauma_type_detail: this.patient.trauma_type_detail || '',
            scenario_type: this.patient.scenario_type || '',
            patient_statement: this.patient.patient_statement
                || this.patient.scenario_description
                || '',
            situation_context: context.situation_context || '',
            visual_triggers: context.visual_triggers || '',
            auditory_triggers: context.auditory_triggers || '',
            emotional_physical_responses: context.emotional_physical_responses || '',
            behavioral_responses: context.behavioral_responses || '',
            treatment_goal: context.treatment_goal || '',
            safety_exclusions: context.safety_exclusions || '',
            additional_notes: context.additional_notes || '',
            scenario_description: this.patient.scenario_description || '',
            scenario_description_attested: !!this.patient.scenario_description_reviewed
        };
        this.originalFormState = this.formState(this.form);
        this.conflictMessage = '';
        this.statementOrganizeMessage = '';
        this.patientPanelOpen = true;
        this.editing = true;
        await this.service.render();
        const focusTarget = this.scenarioReviewMode
            ? 'detail-patient-statement'
            : 'detail-birth-date';
        document.getElementById(focusTarget)?.focus();
    }

    public async onTraumaTypeChange(value: string) {
        this.form.trauma_type = value;
        if (value !== 'other') this.form.trauma_type_detail = '';
        await this.service.render();
        if (value === 'other') {
            setTimeout(() => document.getElementById('detail-trauma-type-detail')?.focus(), 0);
        }
    }

    public traumaTypeLabel(patient: any) {
        if (patient?.trauma_type === 'other' && patient?.trauma_type_detail) {
            return patient.trauma_type_detail;
        }
        return this.labelOf(this.traumaTypes, patient?.trauma_type);
    }

    public async startScenarioReview() {
        await this.startEdit(true);
    }

    private async openRequestedScenarioEditor() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('start') !== 'scenario' || !this.patient || this.editing) return;
        params.delete('start');
        const query = params.toString();
        window.history.replaceState(
            window.history.state,
            '',
            `${window.location.pathname}${query ? `?${query}` : ''}`
        );
        await this.startScenarioReview();
    }

    public async switchToBasicInfoEdit() {
        if (!this.editing || this.saving || this.statementOrganizing) return;
        this.scenarioReviewMode = false;
        await this.service.render();
        setTimeout(() => document.getElementById('detail-birth-date')?.focus(), 0);
    }

    public async cancelEdit() {
        if (this.saving || this.statementOrganizing) return;
        if (!(await this.confirmDiscardChanges())) return;
        const returnToScenarioReview = this.scenarioReviewMode;
        this.editing = false;
        this.scenarioReviewMode = false;
        this.originalFormState = '';
        this.conflictMessage = '';
        await this.service.render();
        setTimeout(
            () => document.getElementById(
                returnToScenarioReview
                    ? 'scenario-review-action'
                    : 'patient-detail-edit-button'
            )?.focus(),
            0
        );
    }

    public async save() {
        if (this.saving || this.statementOrganizing || !this.patient) return;
        if (!this.form.trauma_type) {
            await this.service.modal.error('외상 유형을 선택해주세요.');
            return;
        }
        const traumaTypeDetail = String(this.form.trauma_type_detail || '').trim();
        if (this.form.trauma_type === 'other' && !traumaTypeDetail) {
            await this.service.modal.error('기타 외상 유형을 입력해주세요.');
            return;
        }
        if (traumaTypeDetail.length > this.traumaTypeDetailMaxLength) {
            await this.service.modal.error('기타 외상 유형은 80자 이내로 입력해주세요.');
            return;
        }
        this.form.trauma_type_detail = this.form.trauma_type === 'other'
            ? traumaTypeDetail
            : '';
        if (
            this.form.birth_date
            && (
                String(this.form.birth_date) < '1900-01-01'
                || String(this.form.birth_date) > this.currentDate
            )
        ) {
            await this.service.modal.error('출생년월일을 확인해주세요.');
            return;
        }
        const scenarioDescription = String(
            this.form.scenario_description || ''
        ).trim();
        const patientStatement = String(
            this.form.patient_statement || ''
        ).trim();
        if (this.scenarioReviewMode && !patientStatement) {
            await this.service.modal.error('비식별 환자 진술을 입력해주세요.');
            return;
        }
        if (patientStatement.length > this.patientStatementMaxLength) {
            await this.service.modal.error('비식별 환자 진술은 5,000자 이내로 입력해주세요.');
            return;
        }
        if (this.scenarioReviewMode && !scenarioDescription) {
            await this.service.modal.error('임상 상황 설명 초안을 입력하거나 AI로 작성해주세요.');
            return;
        }
        if (scenarioDescription.length > this.scenarioDescriptionMaxLength) {
            await this.service.modal.error('상황 설명은 1,500자 이내로 입력해주세요.');
            return;
        }
        if (scenarioDescription && !this.form.scenario_description_attested) {
            await this.service.modal.error(
                '환자 동의, 직접 식별정보 제거, 생성 서비스 전송을 담당 임상의가 확인해주세요.'
            );
            return;
        }

        this.saving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save', {
                id: this.patientId,
                ...this.form,
                patient_statement: patientStatement,
                scenario_context: this.scenarioContextPayload(),
                scenario_description: scenarioDescription,
                expected_version: this.patient.row_version,
                csrf_token: this.csrfToken
            });
            if (code === 200) {
                const scenarioReviewCompleted = this.scenarioReviewMode;
                this.patient = data.patient;
                this.csrfToken = data.csrf_token || this.csrfToken;
                this.editing = false;
                this.scenarioReviewMode = false;
                if (scenarioReviewCompleted) this.patientPanelOpen = false;
                this.originalFormState = '';
                this.conflictMessage = '';
                await this.service.modal.success(
                    scenarioReviewCompleted
                        ? '상황 설명 검토가 완료되었습니다. AI 치료 시나리오를 생성할 수 있습니다.'
                        : '환자 정보가 수정되었습니다.'
                );
                setTimeout(
                    () => {
                        const target = document.getElementById(
                            scenarioReviewCompleted
                                ? 'treatment-scenario-action'
                                : 'patient-detail-edit-button'
                        );
                        target?.scrollIntoView({ block: 'center' });
                        target?.focus();
                    },
                    0
                );
                return;
            }
            if (code === 409) {
                this.conflictMessage = this.message(
                    data,
                    '다른 사용자가 환자 정보를 수정했습니다. 최신 정보를 다시 불러와주세요.'
                );
                await this.service.modal.error(this.conflictMessage);
                return;
            }
            await this.service.modal.error(
                this.message(data, '환자 정보를 저장하지 못했습니다.')
            );
        } catch (error) {
            await this.service.modal.error('환자 정보를 저장하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async toggleStatus() {
        if (
            !this.patient
            || this.saving
            || this.editing
            || this.promptEditing
            || this.promptDrafting
            || this.promptSaving
            || this.promptTranslating
            || this.promptTranslationConfirming
        ) return;
        const nextStatus = this.patient.status === 'archived' ? 'active' : 'archived';
        const action = nextStatus === 'archived' ? '보관' : '활성화';
        const confirmed = await this.service.modal.show({
            title: `환자 ${action}`,
            message: `${this.patient.patient_code} 환자를 ${action}하시겠습니까?`,
            action,
            actionBtn: nextStatus === 'archived' ? 'error' : 'success',
            status: nextStatus === 'archived' ? 'error' : 'success'
        });
        if (!confirmed) return;

        this.saving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('set_status', {
                id: this.patientId,
                status: nextStatus,
                expected_version: this.patient.row_version,
                csrf_token: this.csrfToken
            });
            if (code === 200) {
                this.patient = data.patient;
                this.csrfToken = data.csrf_token || this.csrfToken;
                this.editing = false;
                return;
            }
            if (code === 409) {
                await this.service.modal.error(
                    this.message(
                        data,
                        '다른 사용자가 환자 상태를 변경했습니다. 최신 정보를 다시 불러옵니다.'
                    )
                );
                await this.load(true);
                return;
            }
            await this.service.modal.error(
                this.message(data, '환자 상태를 변경하지 못했습니다.')
            );
        } catch (error) {
            await this.service.modal.error('환자 상태를 변경하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public labelOf(options: any[], value: string) {
        return options.find((item: any) => item.value === value)?.label || '미지정';
    }

    public onScenarioDescriptionChange(value: any) {
        void value;
        this.form.scenario_description_attested = false;
    }

    public onPatientStatementChange(value: any) {
        void value;
        this.form.scenario_description_attested = false;
        this.statementOrganizeMessage = '';
    }

    public onScenarioContextChange(value: any) {
        void value;
        this.form.scenario_description_attested = false;
    }

    public patientStatementLength() {
        return String(this.form.patient_statement || '').length;
    }

    private scenarioContextPayload() {
        return {
            situation_context: String(this.form.situation_context || '').trim(),
            visual_triggers: String(this.form.visual_triggers || '').trim(),
            auditory_triggers: String(this.form.auditory_triggers || '').trim(),
            emotional_physical_responses: String(
                this.form.emotional_physical_responses || ''
            ).trim(),
            behavioral_responses: String(this.form.behavioral_responses || '').trim(),
            treatment_goal: String(this.form.treatment_goal || '').trim(),
            safety_exclusions: String(this.form.safety_exclusions || '').trim(),
            additional_notes: String(this.form.additional_notes || '').trim()
        };
    }

    public async organizePatientStatement() {
        if (
            this.statementOrganizing
            || this.saving
            || !this.editing
            || !this.scenarioReviewMode
            || !this.patient
        ) return;
        const statement = String(this.form.patient_statement || '').trim();
        if (!statement) {
            await this.service.modal.error('비식별 환자 진술을 먼저 입력해주세요.');
            return;
        }
        if (statement.length > this.patientStatementMaxLength) {
            await this.service.modal.error('비식별 환자 진술은 5,000자 이내로 입력해주세요.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: 'AI로 환자 진술 정리',
            message: '입력한 비식별 진술을 OpenAI로 전송해 항목별 정보와 임상 상황 설명 초안을 작성합니다. API 사용 비용이 발생할 수 있습니다.',
            action: 'AI 정리 시작',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;

        const requestPatientId = this.patientId;
        const operationSequence = ++this.statementOrganizeOperationSequence;
        this.statementOrganizing = true;
        this.statementOrganizeMessage = 'AI가 진술에서 핵심 정보를 정리하고 있습니다.';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('organize_statement', {
                id: requestPatientId,
                patient_statement: statement,
                expected_version: this.patient.row_version,
                csrf_token: this.csrfToken
            });
            if (
                operationSequence !== this.statementOrganizeOperationSequence
                || requestPatientId !== this.patientId
            ) return;
            if (code === 200) {
                const context = data.scenario_context || {};
                Object.assign(this.form, context, {
                    scenario_description: data.scenario_description || '',
                    scenario_description_attested: false
                });
                this.csrfToken = data.csrf_token || this.csrfToken;
                this.statementOrganizeMessage = 'AI 초안이 준비되었습니다. 각 항목과 최종 설명을 확인하고 필요한 내용을 수정해주세요.';
                await this.service.render();
                setTimeout(
                    () => document.getElementById('detail-situation-context')?.focus(),
                    0
                );
                return;
            }
            this.statementOrganizeMessage = '';
            await this.service.modal.error(
                this.message(data, 'AI가 환자 진술을 정리하지 못했습니다.')
            );
        } catch (error) {
            if (
                operationSequence !== this.statementOrganizeOperationSequence
                || requestPatientId !== this.patientId
            ) return;
            this.statementOrganizeMessage = '';
            await this.service.modal.error('AI가 환자 진술을 정리하지 못했습니다.');
        } finally {
            if (
                operationSequence === this.statementOrganizeOperationSequence
                && requestPatientId === this.patientId
            ) {
                this.statementOrganizing = false;
                await this.service.render();
            }
        }
    }

    public scenarioDescriptionLength() {
        return String(this.form.scenario_description || '').length;
    }

    public treatmentScenarioState() {
        return this.patient?.treatment_scenario || {};
    }

    public treatmentScenarioStatus() {
        const value = String(
            this.treatmentScenarioState()?.status || 'source_not_ready'
        );
        if (['draft_missing', 'review_required', 'approved', 'stale'].includes(value)) {
            return value;
        }
        return 'source_not_ready';
    }

    public treatmentScenario() {
        return this.treatmentScenarioState()?.scenario || {};
    }

    public hasTreatmentScenario() {
        return this.treatmentScenarioState()?.has_draft === true;
    }

    public splitScenarioLines(value: any) {
        return String(value || '')
            .split(/\r?\n/)
            .map((item: string) => item.trim())
            .filter((item: string) => !!item);
    }

    public startTreatmentScenarioReview() {
        const scenario = this.treatmentScenario();
        if (!scenario?.title) return;
        this.treatmentScenarioForm = {
            title: scenario.title || '',
            summary: scenario.summary || '',
            therapeutic_goal: scenario.therapeutic_goal || '',
            trigger_elements: (scenario.trigger_elements || []).join('\n'),
            exposure_steps: (scenario.exposure_steps || []).join('\n'),
            safety_exclusions: (scenario.safety_exclusions || []).join('\n'),
            treatment_scenario_attested: false
        };
        this.treatmentScenarioEditing = true;
        this.treatmentScenarioActionMessage = '';
        setTimeout(() => document.getElementById('treatment-scenario-title')?.focus(), 0);
    }

    public async cancelTreatmentScenarioReview() {
        if (this.treatmentScenarioSaving) return;
        this.treatmentScenarioEditing = false;
        this.treatmentScenarioForm = {};
        await this.service.render();
        setTimeout(() => document.getElementById('treatment-scenario-review-action')?.focus(), 0);
    }

    private resetTreatmentScenarioProgress() {
        this.treatmentScenarioProgress = {
            visible: false,
            status: 'idle',
            stage: '',
            label: '',
            completed_steps: 0,
            total_steps: 0
        };
    }

    private beginTreatmentScenarioProgress(label: string) {
        this.treatmentScenarioProgress = {
            visible: true,
            status: 'in_progress',
            stage: 'submitting',
            label,
            completed_steps: 0,
            total_steps: 5
        };
    }

    private applyTreatmentScenarioProgress(progress: any) {
        const total = Number(progress?.total_steps || 0);
        const completed = Number(progress?.completed_steps || 0);
        if (
            progress?.status !== 'in_progress'
            || !Number.isInteger(total)
            || !Number.isInteger(completed)
            || total <= 0
            || completed < 0
            || completed > total
        ) return;
        this.treatmentScenarioProgress = {
            visible: true,
            status: 'in_progress',
            stage: String(progress.stage || ''),
            label: String(
                progress.label || '서버 작업 상태를 확인하고 있습니다.'
            ),
            completed_steps: completed,
            total_steps: total
        };
    }

    private finishTreatmentScenarioProgress(
        status: 'completed' | 'failed',
        label: string,
        progress: any = null
    ) {
        const currentTotal = Number(
            this.treatmentScenarioProgress?.total_steps || 5
        );
        const suppliedTotal = Number(progress?.total_steps || 0);
        const total = Number.isInteger(suppliedTotal) && suppliedTotal > 0
            ? suppliedTotal
            : currentTotal;
        const completed = status === 'completed'
            ? total
            : Math.max(
                0,
                Math.min(
                    total,
                    Number(
                        this.treatmentScenarioProgress?.completed_steps || 0
                    )
                )
            );
        this.treatmentScenarioProgress = {
            visible: true,
            status,
            stage: status,
            label,
            completed_steps: completed,
            total_steps: total
        };
    }

    private createTreatmentScenarioRequestId() {
        try {
            const bytes = new Uint8Array(16);
            window.crypto.getRandomValues(bytes);
            return Array.from(bytes)
                .map((value) => value.toString(16).padStart(2, '0'))
                .join('');
        } catch (error) {
            return '';
        }
    }

    private stopTreatmentScenarioProgressPolling() {
        ++this.treatmentScenarioProgressPollSequence;
        if (this.treatmentScenarioProgressPollTimer !== null) {
            clearTimeout(this.treatmentScenarioProgressPollTimer);
            this.treatmentScenarioProgressPollTimer = null;
        }
    }

    private startTreatmentScenarioProgressPolling(
        requestId: string,
        refreshWhenIdle: boolean = false,
        requestPatientId: string = this.patientId,
        operationSequence: number = this.treatmentScenarioOperationSequence
    ) {
        this.stopTreatmentScenarioProgressPolling();
        const sequence = this.treatmentScenarioProgressPollSequence;
        const poll = async () => {
            if (
                sequence !== this.treatmentScenarioProgressPollSequence
                || operationSequence !== this.treatmentScenarioOperationSequence
                || requestPatientId !== this.patientId
                || !this.treatmentScenarioGenerating
            ) {
                return;
            }
            try {
                const { code, data } = await wiz.call(
                    'treatment_scenario_progress',
                    {
                        id: requestPatientId,
                        request_id: requestId
                    }
                );
                if (
                    sequence !== this.treatmentScenarioProgressPollSequence
                    || operationSequence
                        !== this.treatmentScenarioOperationSequence
                    || requestPatientId !== this.patientId
                ) return;
                const progress = data?.progress || {};
                if (code === 200 && progress.status === 'in_progress') {
                    this.applyTreatmentScenarioProgress(progress);
                    await this.service.render();
                } else if (code === 200 && refreshWhenIdle) {
                    this.stopTreatmentScenarioProgressPolling();
                    this.treatmentScenarioGenerating = false;
                    await this.load(true);
                    if (this.hasTreatmentScenario()) {
                        this.finishTreatmentScenarioProgress(
                            'completed',
                            'AI 치료 시나리오 생성을 완료했습니다.'
                        );
                        await this.service.render();
                    }
                    return;
                }
            } catch (error) {
                // The generation request owns terminal errors. Poll failures
                // must never invent or advance treatment-scenario progress.
            }
            if (
                sequence !== this.treatmentScenarioProgressPollSequence
                || operationSequence !== this.treatmentScenarioOperationSequence
                || requestPatientId !== this.patientId
                || !this.treatmentScenarioGenerating
            ) {
                return;
            }
            this.treatmentScenarioProgressPollTimer = setTimeout(poll, 750);
        };
        this.treatmentScenarioProgressPollTimer = setTimeout(poll, 250);
    }

    public treatmentScenarioProgressPercent() {
        const total = Number(
            this.treatmentScenarioProgress?.total_steps || 0
        );
        const completed = Number(
            this.treatmentScenarioProgress?.completed_steps || 0
        );
        if (!Number.isFinite(total) || total <= 0) return 0;
        return Math.max(
            0,
            Math.min(100, Math.round(completed * 100 / total))
        );
    }

    public treatmentScenarioProgressStatusLabel() {
        const status = String(
            this.treatmentScenarioProgress?.status || 'idle'
        );
        if (status === 'completed') return '완료';
        if (status === 'failed') return '중단';
        return '진행 중';
    }

    public treatmentScenarioProgressBarClass() {
        const status = String(
            this.treatmentScenarioProgress?.status || 'idle'
        );
        if (status === 'completed') return 'bg-emerald-600';
        if (status === 'failed') return 'bg-red-600';
        return 'bg-indigo-600';
    }

    public canGenerateTreatmentScenario() {
        return !!this.patient
            && this.patient.status === 'active'
            && !!this.patient.scenario_description_reviewed
            && !this.editing
            && !this.promptEditing
            && !this.treatmentScenarioGenerating
            && !this.treatmentScenarioSaving
            && !this.promptDrafting
            && !this.promptSaving;
    }

    public async generateTreatmentScenario(force: boolean = false) {
        if (!this.canGenerateTreatmentScenario()) return;
        if (this.hasTreatmentScenario() && !force) {
            const confirmed = await this.service.modal.show({
                title: 'AI 치료 시나리오 다시 생성',
                message: '현재 치료 시나리오와 임상의 승인이 새 제안으로 교체됩니다. OpenAI API 사용 비용이 발생할 수 있습니다.',
                action: '다시 생성',
                actionBtn: 'warning',
                status: 'warning'
            });
            if (!confirmed) return;
        }
        const requestId = this.createTreatmentScenarioRequestId();
        if (!requestId) {
            this.treatmentScenarioActionMessage =
                '안전한 치료 시나리오 요청 식별값을 만들 수 없습니다. 브라우저를 새로고침한 뒤 다시 시도해주세요.';
            await this.service.modal.error(
                this.treatmentScenarioActionMessage
            );
            return;
        }
        const requestPatientId = this.patientId;
        const operationSequence = ++this.treatmentScenarioOperationSequence;
        this.treatmentScenarioGenerating = true;
        this.treatmentScenarioActionMessage = '';
        this.beginTreatmentScenarioProgress(
            'AI 치료 시나리오 생성 요청을 서버에 전달하고 있습니다.'
        );
        await this.service.render();
        try {
            const scenarioRequest = wiz.call('draft_treatment_scenario', {
                id: requestPatientId,
                expected_version: this.patient.row_version,
                force: this.hasTreatmentScenario() || force,
                request_id: requestId,
                csrf_token: this.csrfToken
            });
            this.startTreatmentScenarioProgressPolling(
                requestId,
                false,
                requestPatientId,
                operationSequence
            );
            const { code, data } = await scenarioRequest;
            if (
                operationSequence !== this.treatmentScenarioOperationSequence
                || requestPatientId !== this.patientId
            ) return;
            if (code === 200 || code === 201) {
                this.patient = data.patient;
                this.csrfToken = data.csrf_token || this.csrfToken;
                this.finishTreatmentScenarioProgress(
                    'completed',
                    data?.progress?.label
                        || 'AI 치료 시나리오 생성을 완료했습니다.',
                    data?.progress
                );
                this.treatmentScenarioActionMessage = '';
                this.startTreatmentScenarioReview();
                if (data.reused) {
                    await this.service.modal.success(
                        '기존 AI 치료 시나리오를 불러왔습니다.'
                    );
                }
                return;
            }
            this.finishTreatmentScenarioProgress(
                'failed',
                this.message(
                    data,
                    'AI 치료 시나리오를 생성하지 못했습니다.'
                )
            );
            this.treatmentScenarioActionMessage = this.message(
                data,
                'AI 치료 시나리오를 생성하지 못했습니다.'
            );
            await this.service.modal.error(
                this.treatmentScenarioActionMessage
            );
            if (code === 409) await this.load(true);
        } catch (error) {
            if (
                operationSequence !== this.treatmentScenarioOperationSequence
                || requestPatientId !== this.patientId
            ) return;
            this.finishTreatmentScenarioProgress(
                'failed',
                'AI 치료 시나리오를 생성하지 못했습니다.'
            );
            this.treatmentScenarioActionMessage =
                'AI 치료 시나리오를 생성하지 못했습니다.';
            await this.service.modal.error(
                this.treatmentScenarioActionMessage
            );
        } finally {
            if (
                operationSequence === this.treatmentScenarioOperationSequence
                && requestPatientId === this.patientId
            ) {
                this.stopTreatmentScenarioProgressPolling();
                this.treatmentScenarioGenerating = false;
                await this.service.render();
            }
        }
    }

    public async approveTreatmentScenario() {
        if (!this.patient || this.treatmentScenarioSaving) return;
        const form = this.treatmentScenarioForm || {};
        const required = [
            String(form.title || '').trim(),
            String(form.summary || '').trim(),
            String(form.therapeutic_goal || '').trim()
        ];
        const triggerElements = this.splitScenarioLines(form.trigger_elements);
        const exposureSteps = this.splitScenarioLines(form.exposure_steps);
        const safetyExclusions = this.splitScenarioLines(form.safety_exclusions);
        if (required.some((value: string) => !value)) {
            await this.service.modal.error('시나리오 제목, 치료 콘텐츠 구성, 치료 목표를 모두 입력해주세요.');
            return;
        }
        if (!triggerElements.length || exposureSteps.length < 3 || !safetyExclusions.length) {
            await this.service.modal.error('유발 요소와 안전 제외 항목을 입력하고 노출 단계를 3개 이상 작성해주세요.');
            return;
        }
        if (!form.treatment_scenario_attested) {
            await this.service.modal.error('담당 임상의의 치료 시나리오 검토 확인이 필요합니다.');
            return;
        }
        this.treatmentScenarioSaving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('approve_treatment_scenario', {
                id: this.patientId,
                expected_version: this.patient.row_version,
                title: required[0],
                summary: required[1],
                therapeutic_goal: required[2],
                trigger_elements: JSON.stringify(triggerElements),
                exposure_steps: JSON.stringify(exposureSteps),
                safety_exclusions: JSON.stringify(safetyExclusions),
                treatment_scenario_attested: true,
                csrf_token: this.csrfToken
            });
            if (code === 200) {
                this.patient = data.patient;
                this.csrfToken = data.csrf_token || this.csrfToken;
                this.treatmentScenarioEditing = false;
                this.treatmentScenarioForm = {};
                await this.service.modal.success(
                    '환자별 치료 시나리오가 승인되었습니다. AI 프롬프트 초안을 생성할 수 있습니다.'
                );
                setTimeout(() => document.getElementById('prompt-draft-action')?.focus(), 0);
                return;
            }
            await this.service.modal.error(
                this.message(data, '치료 시나리오 승인을 저장하지 못했습니다.')
            );
            if (code === 409) await this.load(true);
        } catch (error) {
            await this.service.modal.error('치료 시나리오 승인을 저장하지 못했습니다.');
        } finally {
            this.treatmentScenarioSaving = false;
            await this.service.render();
        }
    }

    public workflowTitle() {
        const step = this.promptWorkflowStep();
        if (step === 1) return '상황 설명 작성·검토';
        if (step === 2) return '환자별 AI 치료 시나리오';
        if (step === 3) return 'AI 프롬프트 초안';
        return '임상의 프롬프트 승인';
    }

    public workflowStatusLabel() {
        const step = this.promptWorkflowStep();
        if (step === 1) return '상황 설명 검토 필요';
        if (step === 2) {
            const status = this.treatmentScenarioStatus();
            if (status === 'review_required') return '치료 시나리오 검토 필요';
            if (status === 'stale') return '치료 시나리오 재생성 필요';
            return '치료 시나리오 생성 필요';
        }
        return this.promptStatusLabel();
    }

    public workflowStatusClass() {
        if (this.promptWorkflowStep() === 2) {
            return this.treatmentScenarioStatus() === 'review_required'
                ? 'border-amber-200 bg-amber-50 text-amber-800'
                : 'border-gray-200 bg-gray-50 text-gray-600';
        }
        return this.promptStatusClass();
    }

    public promptReview() {
        return this.patient?.prompt_review || {};
    }

    public hasPromptDraft() {
        const review = this.promptReview();
        return review?.has_draft === true
            || !!String(review?.positive_prompt || '').trim()
            || !!String(review?.negative_prompt || '').trim();
    }

    public promptStatus(): 'source_not_ready' | 'draft_missing' | 'review_required' | 'approved' | 'stale' {
        if (!this.patient?.scenario_description_reviewed) {
            return 'source_not_ready';
        }
        if (!this.hasPromptDraft()) {
            return 'draft_missing';
        }
        const value = String(this.promptReview()?.status || '').trim();
        if (value === 'stale') return 'stale';
        if (value === 'approved' && this.promptReview()?.ready === true) {
            return 'approved';
        }
        if (value === 'review_required') return 'review_required';
        return 'stale';
    }

    public promptEvidence(key: string) {
        const values = this.promptReview()?.evidence?.[key];
        return Array.isArray(values) ? values : [];
    }

    public async togglePatientPanel() {
        if (this.editing) return;
        this.patientPanelOpen = !this.patientPanelOpen;
        await this.service.render();
    }

    public async closePatientPanel(returnFocus: boolean = false) {
        if (this.editing || !this.patientPanelOpen) return;
        this.patientPanelOpen = false;
        await this.service.render();
        if (returnFocus) {
            setTimeout(() => document.getElementById('workflow-step-1')?.focus(), 0);
        }
    }

    public promptWorkflowStep() {
        const status = this.promptStatus();
        if (status === 'source_not_ready') return 1;
        if (this.treatmentScenarioStatus() !== 'approved') return 2;
        if (status === 'draft_missing' || status === 'stale') return 3;
        return 4;
    }

    public workflowStepState(step: number) {
        const current = this.promptWorkflowStep();
        if (this.promptStatus() === 'approved' && step === 4) return 'complete';
        if (step < current) return 'complete';
        if (step === current) return 'active';
        return 'pending';
    }

    public canSelectWorkflowStep(step: number) {
        const value = Number(step);
        return !!this.patient
            && !this.loading
            && Number.isInteger(value)
            && value >= 1
            && value <= this.promptWorkflowStep();
    }

    public workflowStepNavigationLabel(step: number) {
        const titles: any = {
            1: '상황 설명 작성·검토',
            2: 'AI 치료 시나리오',
            3: 'AI 프롬프트 초안',
            4: '임상의 프롬프트 승인'
        };
        const title = titles[Number(step)] || '치료 콘텐츠 준비 단계';
        if (Number(step) === 1 && this.patientPanelOpen && !this.editing) {
            return `${title} 닫기`;
        }
        return this.canSelectWorkflowStep(step)
            ? `${title} 내용으로 이동`
            : `${title} 단계는 아직 열리지 않았습니다`;
    }

    public async selectWorkflowStep(step: number) {
        const value = Number(step);
        if (!this.canSelectWorkflowStep(value)) return;
        if (value === 1) {
            if (this.patientPanelOpen && !this.editing) {
                await this.closePatientPanel();
                return;
            }
            if (!this.patientPanelOpen) {
                this.patientPanelOpen = true;
                await this.service.render();
            }
        }
        const targets: any = {
            1: ['patient-basic-information'],
            2: [
                'approved-scenario-title',
                'treatment-scenario-review-form',
                'treatment-scenario-review-action',
                'treatment-scenario-action'
            ],
            3: ['prompt-tab-positive', 'prompt-draft-action'],
            4: ['prompt-review-form', 'prompt-approval-checklist-title']
        };
        setTimeout(() => {
            const target = (targets[value] || [])
                .map((id: string) => document.getElementById(id))
                .find((element: HTMLElement | null) => !!element);
            target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 0);
    }

    public promptHasValue(type: 'positive' | 'negative') {
        const source = this.promptEditing ? this.promptForm : this.promptReview();
        return !!String(source?.[`${type}_prompt`] || '').trim();
    }

    public canApprovePrompt() {
        const positive = String(this.promptForm?.positive_prompt || '').trim();
        const negative = String(this.promptForm?.negative_prompt || '').trim();
        return !!this.patient
            && this.patient.status === 'active'
            && this.promptEditing
            && !this.promptSaving
            && !this.promptTranslating
            && !this.promptTranslationConfirming
            && this.promptStatus() !== 'stale'
            && positive.length > 0
            && positive.length <= this.positivePromptMaxLength
            && /[가-힣]/.test(positive)
            && negative.length > 0
            && negative.length <= this.negativePromptMaxLength
            && /[가-힣]/.test(negative)
            && !!this.promptForm.prompt_review_attested;
    }

    public async selectPromptTab(type: 'positive' | 'negative') {
        this.activePromptTab = type;
        await this.service.render();
        setTimeout(
            () => document.getElementById(`prompt-tab-${type}`)?.focus(),
            0
        );
    }

    public async onPromptTabKeydown(
        event: KeyboardEvent,
        type: 'positive' | 'negative'
    ) {
        let next: 'positive' | 'negative' | null = null;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = type === 'positive' ? 'negative' : 'positive';
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = type === 'positive' ? 'negative' : 'positive';
        }
        if (event.key === 'Home') next = 'positive';
        if (event.key === 'End') next = 'negative';
        if (!next) return;
        event.preventDefault();
        await this.selectPromptTab(next);
    }

    public promptStatusLabel() {
        const labels: any = {
            source_not_ready: '상황 설명 검토 필요',
            draft_missing: 'AI 초안 필요',
            review_required: '임상의 검토 필요',
            approved: '임상의 승인 완료',
            stale: '초안 다시 생성 필요'
        };
        return labels[this.promptStatus()];
    }

    public promptStatusClass() {
        const status = this.promptStatus();
        if (status === 'approved') {
            return 'border-green-200 bg-green-50 text-green-700';
        }
        if (['review_required', 'stale'].includes(status)) {
            return 'border-amber-200 bg-amber-50 text-amber-800';
        }
        return 'border-gray-200 bg-gray-50 text-gray-600';
    }

    private currentPromptTranslationPair() {
        const source = this.promptEditing ? this.promptForm : this.promptReview();
        return {
            positive_prompt: String(source?.positive_prompt || '').trim(),
            negative_prompt: String(source?.negative_prompt || '').trim()
        };
    }

    private promptTranslationPairState(pair: any = null) {
        const value = pair || this.currentPromptTranslationPair();
        return JSON.stringify({
            positive_prompt: String(value?.positive_prompt || ''),
            negative_prompt: String(value?.negative_prompt || '')
        });
    }

    public canTranslatePrompt() {
        const pair = this.currentPromptTranslationPair();
        return !!this.patient
            && this.patient.status === 'active'
            && this.hasPromptDraft()
            && this.promptStatus() !== 'stale'
            && pair.positive_prompt.length > 0
            && pair.positive_prompt.length <= this.positivePromptMaxLength
            && pair.negative_prompt.length > 0
            && pair.negative_prompt.length <= this.negativePromptMaxLength
            && !this.saving
            && !this.editing
            && !this.promptDrafting
            && !this.promptDraftConfirming
            && !this.promptSaving
            && !this.promptTranslating
            && !this.promptTranslationConfirming;
    }

    public promptTranslationText(type: 'positive' | 'negative') {
        return String(
            this.promptTranslation?.[`${type}_prompt_ko`] || ''
        );
    }

    public promptTranslationActionLabel() {
        if (this.promptTranslationConfirming) return '번역 확인 중...';
        if (this.promptTranslating) return '한국어 번역 중...';
        if (['ready', 'stale', 'failed'].includes(
            String(this.promptTranslation?.status || '')
        )) {
            return '한국어 번역 새로고침 · API 비용 발생';
        }
        return '한국어 번역 보기 · API 비용 발생';
    }

    private resetPromptTranslation() {
        ++this.promptTranslationOperationSequence;
        this.promptTranslationRequestSequence = 0;
        this.promptTranslating = false;
        this.promptTranslationConfirming = false;
        this.promptTranslation = {
            visible: false,
            status: 'idle',
            message: '',
            positive_prompt_ko: '',
            negative_prompt_ko: ''
        };
    }

    private markPromptTranslationStale() {
        const status = String(this.promptTranslation?.status || 'idle');
        if (status === 'idle') return;
        ++this.promptTranslationOperationSequence;
        this.promptTranslationConfirming = false;
        this.promptTranslation = {
            ...this.promptTranslation,
            visible: true,
            status: 'stale',
            message: this.promptTranslating
                ? '프롬프트가 변경되어 진행 중인 번역을 적용하지 않습니다. 현재 요청이 끝난 뒤 다시 번역해주세요.'
                : '프롬프트가 변경되어 번역이 이전 버전입니다. 현재 내용으로 다시 번역해주세요.'
        };
    }

    private async focusPromptTranslationStatus() {
        await this.service.render();
        setTimeout(
            () => document.getElementById('prompt-translation-status')?.focus(),
            0
        );
    }

    public async translatePrompt() {
        if (!this.canTranslatePrompt()) return;

        const confirmationPatientId = this.patientId;
        const operationSequence = ++this.promptTranslationOperationSequence;
        this.promptTranslationConfirming = true;
        await this.service.render();
        let confirmed = false;
        try {
            confirmed = await this.service.modal.show({
                title: '프롬프트 한국어 번역',
                message: '현재 Positive·Negative 프롬프트를 참고용 한국어로 번역하기 위해 외부 AI 서비스로 전송합니다. 번역은 승인본이나 콘텐츠 생성 입력을 바꾸지 않으며 API 사용 비용이 발생할 수 있습니다.',
                action: '한국어로 번역',
                actionBtn: 'warning',
                status: 'warning'
            });
        } finally {
            if (
                operationSequence === this.promptTranslationOperationSequence
                && confirmationPatientId === this.patientId
            ) {
                this.promptTranslationConfirming = false;
                await this.service.render();
            }
        }
        if (
            !confirmed
            || operationSequence !== this.promptTranslationOperationSequence
            || confirmationPatientId !== this.patientId
        ) return;

        const pair = this.currentPromptTranslationPair();
        const pairState = this.promptTranslationPairState(pair);
        const expectedVersion = this.patient.row_version;
        this.promptTranslationRequestSequence = operationSequence;
        this.promptTranslating = true;
        this.promptTranslation = {
            ...this.promptTranslation,
            visible: true,
            status: 'loading',
            message: '외부 AI 서비스에서 실제 번역 응답을 기다리고 있습니다.'
        };
        await this.service.render();

        try {
            const { code, data } = await wiz.call('translate_prompt', {
                id: confirmationPatientId,
                expected_version: expectedVersion,
                positive_prompt: pair.positive_prompt,
                negative_prompt: pair.negative_prompt,
                csrf_token: this.csrfToken
            });
            if (
                operationSequence !== this.promptTranslationOperationSequence
                || confirmationPatientId !== this.patientId
                || pairState !== this.promptTranslationPairState()
            ) return;

            if (code === 200) {
                const translation = data?.translation || {};
                const positive = String(translation.positive_prompt_ko || '').trim();
                const negative = String(translation.negative_prompt_ko || '').trim();
                if (translation.language !== 'ko' || !positive || !negative) {
                    this.promptTranslation = {
                        ...this.promptTranslation,
                        status: 'failed',
                        message: '한국어 번역 응답을 확인할 수 없습니다. 다시 시도해주세요.'
                    };
                    await this.focusPromptTranslationStatus();
                    return;
                }
                this.csrfToken = data.csrf_token || this.csrfToken;
                this.promptTranslation = {
                    visible: true,
                    status: 'ready',
                    message: '현재 영어 프롬프트와 일치하는 참고용 한국어 번역입니다.',
                    positive_prompt_ko: positive,
                    negative_prompt_ko: negative
                };
                await this.service.render();
                return;
            }

            this.promptTranslation = {
                ...this.promptTranslation,
                status: 'failed',
                message: this.message(
                    data,
                    code === 409
                        ? '프롬프트가 변경되어 번역을 적용하지 않았습니다. 현재 내용을 확인한 뒤 다시 시도해주세요.'
                        : '한국어 번역을 완료하지 못했습니다. 다시 시도해주세요.'
                )
            };
            await this.focusPromptTranslationStatus();
        } catch (error) {
            if (
                operationSequence !== this.promptTranslationOperationSequence
                || confirmationPatientId !== this.patientId
                || pairState !== this.promptTranslationPairState()
            ) return;
            this.promptTranslation = {
                ...this.promptTranslation,
                status: 'failed',
                message: '한국어 번역을 완료하지 못했습니다. 네트워크 상태를 확인하고 다시 시도해주세요.'
            };
            await this.focusPromptTranslationStatus();
        } finally {
            if (
                operationSequence === this.promptTranslationRequestSequence
                && confirmationPatientId === this.patientId
            ) {
                this.promptTranslationRequestSequence = 0;
                this.promptTranslating = false;
                await this.service.render();
            }
        }
    }

    public promptDraftProgressPercent() {
        const completed = Number(
            this.promptDraftProgress?.completed_steps || 0
        );
        const total = Number(this.promptDraftProgress?.total_steps || 0);
        if (!Number.isFinite(completed) || !Number.isFinite(total) || total <= 0) {
            return 0;
        }
        return Math.max(0, Math.min(100, Math.round(completed * 100 / total)));
    }

    public promptDraftProgressStatusLabel() {
        const status = String(this.promptDraftProgress?.status || '');
        if (status === 'completed') return '완료';
        if (status === 'failed') return '실패';
        return '진행 중';
    }

    public promptDraftProgressBarClass() {
        const status = String(this.promptDraftProgress?.status || '');
        if (status === 'completed') return 'bg-emerald-600';
        if (status === 'failed') return 'bg-red-600';
        return 'bg-indigo-600';
    }

    public promptDraftActionBusy() {
        return this.saving
            || this.editing
            || this.promptEditing
            || this.treatmentScenarioGenerating
            || this.treatmentScenarioSaving
            || this.promptDraftConfirming
            || this.promptDrafting
            || this.promptSaving
            || this.promptTranslating
            || this.promptTranslationConfirming;
    }

    private promptDraftBlockReason(requireReviewed: boolean) {
        if (!this.patient) return '환자 정보를 먼저 불러와주세요.';
        if (this.patient.status !== 'active') {
            return '보관된 환자는 AI 초안을 만들 수 없습니다. 먼저 환자를 활성화해주세요.';
        }
        if (!String(this.patient.scenario_description || '').trim()) {
            return 'AI 초안에 사용할 비식별 상황 설명을 먼저 입력해주세요.';
        }
        if (this.treatmentScenarioStatus() !== 'approved') {
            return '환자 진술 기반 AI 치료 시나리오를 생성하고 담당 임상의 승인을 완료해주세요.';
        }
        if (!this.patient.scenario_type) {
            return '승인된 치료 시나리오의 내부 프롬프트 템플릿을 사용할 수 없습니다.';
        }
        if (requireReviewed && !this.patient.scenario_description_reviewed) {
            return '현재 상황 설명의 임상의 검토를 먼저 완료해주세요.';
        }
        if (this.saving) return '상황 설명을 저장하고 있습니다. 잠시만 기다려주세요.';
        if (this.editing) return '환자 정보 편집을 저장하거나 취소한 뒤 다시 시도해주세요.';
        if (this.promptEditing) return '프롬프트 검토를 저장하거나 취소한 뒤 다시 시도해주세요.';
        if (this.promptDraftConfirming) return 'AI 초안 생성 확인 창이 이미 열려 있습니다.';
        if (this.promptDrafting) return 'AI 초안을 이미 생성하고 있습니다.';
        if (this.promptSaving) return '프롬프트 승인을 저장하고 있습니다. 잠시만 기다려주세요.';
        if (this.promptTranslationConfirming) return '한국어 번역 확인 창이 이미 열려 있습니다.';
        if (this.promptTranslating) return '한국어 번역이 끝난 뒤 AI 초안을 다시 생성해주세요.';
        return '';
    }

    private async showPromptDraftBlockReason(reason: string) {
        this.promptActionMessage = reason;
        await this.service.render();
        setTimeout(
            () => document.getElementById('prompt-draft-action-message')?.focus(),
            0
        );
    }

    private resetPromptDraftProgress() {
        this.promptDraftProgress = {
            visible: false,
            status: 'idle',
            stage: '',
            label: '',
            completed_steps: 0,
            total_steps: 0
        };
    }

    private beginPromptDraftProgress(label: string) {
        this.promptDraftProgress = {
            visible: true,
            status: 'in_progress',
            stage: 'submitting',
            label,
            completed_steps: 0,
            total_steps: 5
        };
    }

    private applyPromptDraftProgress(progress: any) {
        const total = Number(progress?.total_steps || 0);
        const completed = Number(progress?.completed_steps || 0);
        if (
            progress?.status !== 'in_progress'
            || !Number.isInteger(total)
            || !Number.isInteger(completed)
            || total <= 0
            || completed < 0
            || completed > total
        ) return;
        this.promptDraftProgress = {
            visible: true,
            status: 'in_progress',
            stage: String(progress.stage || ''),
            label: String(progress.label || '서버 작업 상태를 확인하고 있습니다.'),
            completed_steps: completed,
            total_steps: total
        };
    }

    private finishPromptDraftProgress(
        status: 'completed' | 'failed',
        label: string,
        progress: any = null
    ) {
        const currentTotal = Number(this.promptDraftProgress?.total_steps || 5);
        const suppliedTotal = Number(progress?.total_steps || 0);
        const total = Number.isInteger(suppliedTotal) && suppliedTotal > 0
            ? suppliedTotal
            : currentTotal;
        const completed = status === 'completed'
            ? total
            : Math.max(
                0,
                Math.min(
                    total,
                    Number(this.promptDraftProgress?.completed_steps || 0)
                )
            );
        this.promptDraftProgress = {
            visible: true,
            status,
            stage: status,
            label,
            completed_steps: completed,
            total_steps: total
        };
    }

    private createPromptDraftRequestId() {
        try {
            const bytes = new Uint8Array(16);
            window.crypto.getRandomValues(bytes);
            return Array.from(bytes)
                .map((value) => value.toString(16).padStart(2, '0'))
                .join('');
        } catch (error) {
            return '';
        }
    }

    private stopPromptDraftProgressPolling() {
        ++this.promptDraftProgressPollSequence;
        if (this.promptDraftProgressPollTimer !== null) {
            clearTimeout(this.promptDraftProgressPollTimer);
            this.promptDraftProgressPollTimer = null;
        }
    }

    private startPromptDraftProgressPolling(
        requestId: string,
        refreshWhenIdle: boolean = false,
        requestPatientId: string = this.patientId,
        operationSequence: number = this.promptDraftOperationSequence
    ) {
        this.stopPromptDraftProgressPolling();
        const sequence = this.promptDraftProgressPollSequence;
        const poll = async () => {
            if (
                sequence !== this.promptDraftProgressPollSequence
                || operationSequence !== this.promptDraftOperationSequence
                || requestPatientId !== this.patientId
                || !this.promptDrafting
            ) {
                return;
            }
            try {
                const { code, data } = await wiz.call('draft_prompt_progress', {
                    id: requestPatientId,
                    request_id: requestId
                });
                if (
                    sequence !== this.promptDraftProgressPollSequence
                    || operationSequence !== this.promptDraftOperationSequence
                    || requestPatientId !== this.patientId
                ) return;
                const progress = data?.progress || {};
                if (code === 200 && progress.status === 'in_progress') {
                    this.applyPromptDraftProgress(progress);
                    await this.service.render();
                } else if (code === 200 && refreshWhenIdle) {
                    this.stopPromptDraftProgressPolling();
                    this.promptDrafting = false;
                    await this.load(true);
                    if (this.hasPromptDraft()) {
                        this.finishPromptDraftProgress(
                            'completed',
                            'AI 프롬프트 초안 생성을 완료했습니다.'
                        );
                        await this.service.render();
                    }
                    return;
                }
            } catch (error) {
                // The primary generation request owns terminal error handling.
                // A transient read failure must not invent or advance progress.
            }
            if (
                sequence !== this.promptDraftProgressPollSequence
                || operationSequence !== this.promptDraftOperationSequence
                || requestPatientId !== this.patientId
                || !this.promptDrafting
            ) {
                return;
            }
            this.promptDraftProgressPollTimer = setTimeout(poll, 750);
        };
        this.promptDraftProgressPollTimer = setTimeout(poll, 250);
    }

    public canDraftPrompt() {
        return !!this.patient
            && this.patient.status === 'active'
            && !!this.patient.scenario_description_reviewed
            && this.treatmentScenarioStatus() === 'approved'
            && !!this.patient.scenario_type
            && !this.editing
            && !this.promptEditing
            && !this.promptDrafting
            && !this.promptSaving
            && !this.promptTranslating
            && !this.promptTranslationConfirming;
    }

    public canReviewAndDraftPrompt() {
        return !!this.patient
            && this.patient.status === 'active'
            && !!String(this.patient.scenario_description || '').trim()
            && !!this.patient.scenario_type
            && !this.saving
            && !this.editing
            && !this.promptEditing
            && !this.promptDrafting
            && !this.promptSaving
            && !this.promptTranslating
            && !this.promptTranslationConfirming;
    }

    public async reviewAndGeneratePromptDraft() {
        const blocked = this.promptDraftBlockReason(false);
        if (blocked) {
            await this.showPromptDraftBlockReason(blocked);
            return;
        }
        this.promptDraftConfirming = true;
        this.promptActionMessage = '확인 후 생성을 시작할 수 있도록 확인 창을 열었습니다.';
        await this.service.render();
        let confirmed = false;
        try {
            confirmed = await this.service.modal.show({
                title: '상황 설명 확인 및 AI 초안 생성',
                message: '현재 상황 설명에 환자 동의, 직접 식별정보 제거, 생성 서비스 전송 적합성을 확인하고 AI 초안을 생성합니다. OpenAI API 사용 비용이 발생할 수 있습니다.',
                action: '확인하고 생성',
                actionBtn: 'warning',
                status: 'warning'
            });
        } finally {
            this.promptDraftConfirming = false;
        }
        this.promptActionMessage = '';
        if (!confirmed) {
            await this.service.render();
            return;
        }

        const requestPatientId = this.patientId;
        this.resetPromptTranslation();
        const operationSequence = ++this.promptDraftOperationSequence;
        this.promptDrafting = true;
        this.beginPromptDraftProgress('상황 설명 검토 내용을 저장하고 있습니다.');
        await this.service.render();
        let reviewSaved = false;
        try {
            const { code, data } = await wiz.call('save', {
                id: requestPatientId,
                birth_date: this.patient.birth_date || '',
                birth_year: this.patient.birth_year || '',
                gender: this.patient.gender || 'unspecified',
                trauma_type: this.patient.trauma_type || 'other',
                trauma_type_detail: this.patient.trauma_type_detail || '',
                scenario_type: this.patient.scenario_type || '',
                patient_statement: this.patient.patient_statement || '',
                scenario_context: this.patient.scenario_context || {},
                scenario_description: this.patient.scenario_description || '',
                scenario_description_attested: true,
                expected_version: this.patient.row_version,
                csrf_token: this.csrfToken
            });
            if (
                operationSequence !== this.promptDraftOperationSequence
                || requestPatientId !== this.patientId
            ) return;
            if (code === 200) {
                this.patient = data.patient;
                this.csrfToken = data.csrf_token || this.csrfToken;
                reviewSaved = true;
            } else if (code === 409) {
                this.finishPromptDraftProgress(
                    'failed',
                    this.message(
                        data,
                        '상황 설명이 변경되었습니다. 최신 정보를 다시 확인해주세요.'
                    )
                );
                await this.service.modal.error(
                    this.message(
                        data,
                        '상황 설명이 변경되었습니다. 최신 정보를 다시 확인해주세요.'
                    )
                );
                await this.load(true);
            } else {
                this.finishPromptDraftProgress(
                    'failed',
                    this.message(data, '상황 설명 검토를 저장하지 못했습니다.')
                );
                await this.service.modal.error(
                    this.message(data, '상황 설명 검토를 저장하지 못했습니다.')
                );
            }
        } catch (error) {
            if (
                operationSequence !== this.promptDraftOperationSequence
                || requestPatientId !== this.patientId
            ) return;
            this.finishPromptDraftProgress(
                'failed',
                '상황 설명 검토를 저장하지 못했습니다.'
            );
            await this.service.modal.error('상황 설명 검토를 저장하지 못했습니다.');
        } finally {
            if (
                operationSequence === this.promptDraftOperationSequence
                && requestPatientId === this.patientId
            ) {
                this.promptDrafting = false;
                await this.service.render();
            }
        }
        if (
            reviewSaved
            && operationSequence === this.promptDraftOperationSequence
            && requestPatientId === this.patientId
        ) await this.generatePromptDraft(true);
    }

    public async generatePromptDraft(skipRegenerationConfirmation: boolean = false) {
        const blocked = this.promptDraftBlockReason(true);
        if (blocked) {
            await this.showPromptDraftBlockReason(blocked);
            return;
        }
        this.promptActionMessage = '';
        const hasDraft = this.hasPromptDraft();
        if (hasDraft && !skipRegenerationConfirmation) {
            this.promptDraftConfirming = true;
            await this.service.render();
            let confirmed = false;
            try {
                confirmed = await this.service.modal.show({
                    title: 'AI 초안 다시 생성',
                    message: '현재 프롬프트와 승인이 새 AI 초안으로 교체됩니다. OpenAI API 사용 비용이 추가로 발생할 수 있습니다.',
                    action: '다시 생성',
                    actionBtn: 'warning',
                    status: 'warning'
                });
            } finally {
                this.promptDraftConfirming = false;
            }
            if (!confirmed) return;
        }

        const requestId = this.createPromptDraftRequestId();
        if (!requestId) {
            await this.showPromptDraftBlockReason(
                '안전한 AI 초안 요청 식별값을 만들 수 없습니다. 브라우저를 새로고침한 뒤 다시 시도해주세요.'
            );
            return;
        }
        this.resetPromptTranslation();
        const requestPatientId = this.patientId;
        const operationSequence = ++this.promptDraftOperationSequence;
        this.promptDrafting = true;
        this.beginPromptDraftProgress('AI 초안 생성 요청을 서버에 전달하고 있습니다.');
        await this.service.render();
        try {
            const draftRequest = wiz.call('draft_prompt', {
                id: requestPatientId,
                expected_version: this.patient.row_version,
                force: hasDraft,
                request_id: requestId,
                csrf_token: this.csrfToken
            });
            this.startPromptDraftProgressPolling(
                requestId,
                false,
                requestPatientId,
                operationSequence
            );
            const { code, data } = await draftRequest;
            if (
                operationSequence !== this.promptDraftOperationSequence
                || requestPatientId !== this.patientId
            ) return;
            if (code === 200 || code === 201) {
                this.patient = data.patient;
                this.csrfToken = data.csrf_token || this.csrfToken;
                this.finishPromptDraftProgress(
                    'completed',
                    data?.progress?.label || 'AI 프롬프트 초안 생성을 완료했습니다.',
                    data?.progress
                );
                await this.startPromptReview();
                if (data.reused) {
                    await this.service.modal.success('기존 AI 초안을 불러왔습니다.');
                }
                return;
            }
            if (code === 409) {
                this.finishPromptDraftProgress(
                    'failed',
                    this.message(
                        data,
                        '상황 설명이 변경되었습니다. 최신 정보를 다시 확인해주세요.'
                    )
                );
                await this.service.modal.error(
                    this.message(data, '상황 설명이 변경되었습니다. 최신 정보를 다시 확인해주세요.')
                );
                await this.load(true);
                return;
            }
            this.finishPromptDraftProgress(
                'failed',
                this.message(data, 'AI 프롬프트 초안을 만들지 못했습니다.')
            );
            await this.service.modal.error(
                this.message(data, 'AI 프롬프트 초안을 만들지 못했습니다.')
            );
        } catch (error) {
            if (
                operationSequence !== this.promptDraftOperationSequence
                || requestPatientId !== this.patientId
            ) return;
            this.finishPromptDraftProgress(
                'failed',
                'AI 프롬프트 초안을 만들지 못했습니다.'
            );
            await this.service.modal.error('AI 프롬프트 초안을 만들지 못했습니다.');
        } finally {
            if (
                operationSequence === this.promptDraftOperationSequence
                && requestPatientId === this.patientId
            ) {
                this.stopPromptDraftProgressPolling();
                this.promptDrafting = false;
                await this.service.render();
            }
        }
    }

    public startPromptReview() {
        if (
            !this.patient
            || !this.hasPromptDraft()
            || this.editing
            || this.promptTranslating
            || this.promptTranslationConfirming
        ) return;
        this.promptForm = {
            positive_prompt: this.promptReview()?.positive_prompt || '',
            negative_prompt: this.promptReview()?.negative_prompt || '',
            prompt_review_attested: false
        };
        this.activePromptTab = 'positive';
        this.originalPromptFormState = this.promptFormState(this.promptForm);
        this.promptEditing = true;
        setTimeout(
            () => document.getElementById('prompt-positive')?.focus(),
            0
        );
    }

    public async cancelPromptReview() {
        if (
            this.promptSaving
            || this.promptTranslating
            || this.promptTranslationConfirming
        ) return;
        if (!(await this.confirmDiscardChanges())) return;
        this.resetPromptTranslation();
        this.promptEditing = false;
        this.originalPromptFormState = '';
        await this.service.render();
    }

    public onPromptChange(value: any) {
        void value;
        this.promptForm.prompt_review_attested = false;
        this.markPromptTranslationStale();
    }

    public positivePromptLength() {
        return String(this.promptForm.positive_prompt || '').length;
    }

    public negativePromptLength() {
        return String(this.promptForm.negative_prompt || '').length;
    }

    public async approvePrompt() {
        if (
            !this.patient
            || this.promptSaving
            || !this.promptEditing
            || this.promptTranslating
            || this.promptTranslationConfirming
        ) return;
        const positive = String(this.promptForm.positive_prompt || '').trim();
        const negative = String(this.promptForm.negative_prompt || '').trim();
        if (!positive || !negative) {
            await this.service.modal.error('한국어 Positive와 Negative 프롬프트를 모두 입력해주세요.');
            return;
        }
        if (!/[가-힣]/.test(positive) || !/[가-힣]/.test(negative)) {
            await this.service.modal.error('임상의 승인 프롬프트는 한국어로 입력해주세요.');
            return;
        }
        if (positive.length > this.positivePromptMaxLength) {
            await this.service.modal.error('Positive 프롬프트는 3,000자 이내로 입력해주세요.');
            return;
        }
        if (negative.length > this.negativePromptMaxLength) {
            await this.service.modal.error('Negative 프롬프트는 1,500자 이내로 입력해주세요.');
            return;
        }
        if (!this.promptForm.prompt_review_attested) {
            await this.service.modal.error('담당 임상의의 프롬프트 적합성 확인이 필요합니다.');
            return;
        }

        this.promptSaving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('approve_prompt', {
                id: this.patientId,
                positive_prompt: positive,
                negative_prompt: negative,
                prompt_review_attested: true,
                expected_version: this.patient.row_version,
                csrf_token: this.csrfToken
            });
            if (code === 200) {
                this.patient = data.patient;
                this.csrfToken = data.csrf_token || this.csrfToken;
                this.promptEditing = false;
                this.originalPromptFormState = '';
                await this.service.modal.success('한국어 프롬프트 승인과 미디어 생성용 영어 파생본 준비가 완료되었습니다.');
                return;
            }
            if (code === 409) {
                await this.service.modal.error(
                    this.message(data, '상황 설명 또는 AI 초안이 변경되었습니다.')
                );
                await this.load(true);
                return;
            }
            await this.service.modal.error(
                this.message(data, '프롬프트 승인을 저장하지 못했습니다.')
            );
        } catch (error) {
            await this.service.modal.error('프롬프트 승인을 저장하지 못했습니다.');
        } finally {
            this.promptSaving = false;
            await this.service.render();
        }
    }

    public hasUnsavedChanges() {
        const patientFormChanged = this.editing
            && !!this.originalFormState
            && this.formState(this.form) !== this.originalFormState;
        const promptFormChanged = this.promptEditing
            && !!this.originalPromptFormState
            && this.promptFormState(this.promptForm) !== this.originalPromptFormState;
        return patientFormChanged || promptFormChanged;
    }

    public backToPatients() {
        const fromContent = this.route.snapshot.queryParamMap.get('from') === 'content';
        if (fromContent && /^[0-9a-f]{32}$/.test(this.patientId)) {
            this.service.href(
                '/content?patient_id=' + encodeURIComponent(this.patientId)
            );
            return;
        }
        this.service.href('/patients');
    }

    public canOpenContentWorkbench() {
        return this.can('content.write')
            && !!this.patient
            && this.patient.status === 'active'
            && this.promptStatus() === 'approved'
            && /^[0-9a-f]{32}$/.test(this.patientId)
            && !this.saving
            && !this.editing
            && !this.promptEditing
            && !this.promptDraftConfirming
            && !this.promptDrafting
            && !this.promptSaving
            && !this.promptTranslationConfirming
            && !this.promptTranslating;
    }

    public async openContentWorkbench() {
        if (!this.canOpenContentWorkbench()) return;
        await this.router.navigate(['/content'], {
            queryParams: { patient_id: this.patientId }
        });
    }

    public async reloadAfterConflict() {
        if (!(await this.confirmDiscardChanges())) return;
        this.editing = false;
        this.scenarioReviewMode = false;
        this.originalFormState = '';
        this.conflictMessage = '';
        await this.load(true);
    }

    @HostListener('window:beforeunload', ['$event'])
    public protectBeforeUnload(event: BeforeUnloadEvent) {
        if (!this.hasUnsavedChanges() || this.sessionEndApproved) return;
        event.preventDefault();
        event.returnValue = '';
    }

    @HostListener('window:ptsd:before-session-end', ['$event'])
    public protectSessionEnd(event: Event) {
        if (!this.hasUnsavedChanges()) return;
        if (window.confirm(this.discardWarning())) {
            this.sessionEndApproved = true;
            return;
        }
        event.preventDefault();
    }

    public async canDeactivate(): Promise<boolean> {
        if (this.sessionEndApproved || !this.hasUnsavedChanges()) return true;
        if (!this.navigationConfirmation) {
            this.navigationConfirmation = this.confirmDiscardChanges();
        }
        try {
            return await this.navigationConfirmation;
        } finally {
            this.navigationConfirmation = null;
        }
    }

    private formState(value: any) {
        return JSON.stringify({
            birth_date: String(value?.birth_date || ''),
            birth_year: String(value?.birth_year || ''),
            gender: String(value?.gender || ''),
            trauma_type: String(value?.trauma_type || ''),
            trauma_type_detail: String(value?.trauma_type_detail || ''),
            scenario_type: String(value?.scenario_type || ''),
            patient_statement: String(value?.patient_statement || ''),
            situation_context: String(value?.situation_context || ''),
            visual_triggers: String(value?.visual_triggers || ''),
            auditory_triggers: String(value?.auditory_triggers || ''),
            emotional_physical_responses: String(
                value?.emotional_physical_responses || ''
            ),
            behavioral_responses: String(value?.behavioral_responses || ''),
            treatment_goal: String(value?.treatment_goal || ''),
            safety_exclusions: String(value?.safety_exclusions || ''),
            additional_notes: String(value?.additional_notes || ''),
            scenario_description: String(value?.scenario_description || ''),
            scenario_description_attested: !!value?.scenario_description_attested
        });
    }

    private promptFormState(value: any) {
        return JSON.stringify({
            positive_prompt: String(value?.positive_prompt || ''),
            negative_prompt: String(value?.negative_prompt || ''),
            prompt_review_attested: !!value?.prompt_review_attested
        });
    }

    private discardWarning() {
        return '저장하지 않은 환자 정보 또는 프롬프트가 있습니다. 변경 내용을 버리고 이동하시겠습니까?';
    }

    private async confirmDiscardChanges() {
        if (!this.hasUnsavedChanges()) return true;
        return !!(await this.service.modal.show({
            title: '저장하지 않은 변경 내용',
            message: this.discardWarning(),
            action: '변경 내용 버리기',
            actionBtn: 'error',
            status: 'error'
        }));
    }

    public statusLabel(status: string) {
        return status === 'archived' ? '보관' : '활성';
    }

    public statusClass(status: string) {
        return status === 'archived'
            ? 'bg-gray-100 text-gray-600 border border-gray-200'
            : 'bg-green-50 text-green-700 border border-green-200';
    }

    public ageBand(birthYear: any) {
        if (!birthYear) return '미입력';
        const age = Math.max(0, this.currentYear - Number(birthYear));
        if (age >= 100) return '100세 이상';
        if (age < 10) return '10세 미만';
        return `${Math.floor(age / 10) * 10}대`;
    }
}

export default PagePatientsDetailComponent;